import React, { useEffect, useRef, useState } from 'react';
import { CircleHelp, Loader2 } from 'lucide-react';

export default function InvoiceTourHelp({ rootRef, screen, contextKey, disabled }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const buttonRef = useRef(null);
    const tourRef = useRef(null);
    const generation = useRef(0);
    useEffect(() => {
        setLoading(false); setError('');
        return () => {
            generation.current += 1;
            tourRef.current?.destroy(); tourRef.current = null;
        };
    }, [contextKey, disabled]);
    const start = async () => {
        if (disabled || loading) return;
        const ticket = ++generation.current;
        setLoading(true); setError('');
        try {
            const { startInvoiceTour } = await import('./invoiceTour');
            if (ticket !== generation.current || !rootRef.current?.isConnected || document.querySelector('dialog[open]')) return;
            tourRef.current?.destroy();
            tourRef.current = startInvoiceTour(rootRef.current, screen, buttonRef.current);
        } catch {
            if (ticket === generation.current) setError('No se ha podido abrir la ayuda. Pulsa el icono para reintentar.');
        } finally {
            if (ticket === generation.current) setLoading(false);
        }
    };
    return <div className="esave-tour-help">
        <button ref={buttonRef} type="button" data-tour="help" className="esave-tour-trigger" disabled={disabled || loading} aria-label="Ayuda: ver tour de esta pantalla" aria-haspopup="dialog" aria-busy={loading} title="Ayuda de esta pantalla" onClick={start}>
            {loading ? <Loader2 size={21} className="animate-spin" aria-hidden="true" /> : <CircleHelp size={21} aria-hidden="true" />}
        </button>
        {error && <span className="esave-tour-error" role="alert">{error}</span>}
    </div>;
}
